export const EVENTS = {
  onSubscriptionError: 'onSubscriptionError',
  onSubscriptionUpdateNotification: 'onSubscriptionUpdateNotification',
};

export const CRUDMethods = {
  GET: 'get',
  POST: 'post',
  DELETE: 'delete',
  HEAD: 'head',
  OPTIONS: 'options',
  PUT: 'put',
  PATCH: 'patch',
};

export default {
  EVENTS,
  CRUDMethods,
};



// WEBPACK FOOTER //
// ./src/api-layer/consts.js